import {WalletPaymentSubmissionFailure, WalletPaymentSubmissionResult, WalletProvider} from "../payment";
import {PaymentModel} from "../payment.model";

export abstract class WalletPaymentProcessor {
    public walletProvider: WalletProvider;
    public quickPayAvailable: boolean = false;
    public canSubmit: boolean = true;

    protected resolveSubmission: (value?: WalletPaymentSubmissionResult | PromiseLike<WalletPaymentSubmissionResult>) => void;
    protected rejectSubmission: (reason?: WalletPaymentSubmissionFailure) => void;

    protected constructor(protected paymentModel: PaymentModel) {
    }

    public abstract init(): Promise<WalletPaymentProcessor>;

    public abstract submit(amount: number): Promise<WalletPaymentSubmissionResult>;
}



// WEBPACK FOOTER //
// ./src/app/payment/wallet-payment/wallet-payment-processor.ts